/**
 * GA4 (gtag.js) 설정값.
 * 렌더러(webpack) 빌드 시 process.env.NX_* 가 리터럴로 치환되어 주입된다.
 *
 * web 렌더러에서 gtag.js 로 직접 전송하는 방식이므로 측정 ID 만 필요하다.
 * (Measurement Protocol 의 API Secret 은 사용하지 않는다.)
 */
export const GA_MEASUREMENT_ID = process.env['NX_GA_MEASUREMENT_ID'];
